import React, { useEffect, useState } from "react";
import { FiHome } from "react-icons/fi";
import { Link } from "react-router-dom";
import { useParams } from "react-router";
import { useCookies } from "react-cookie";
import axios from "axios";
import $ from "jquery";

import "../css/users.css";

import HeaderSearchBar from "../components/headerSearchBar";

export default function Users() {

    const [cookies, setCookie, removeCookie, removeCookies] = useCookies(["userPuuId"]);

    let { userid } = useParams();

    const [ username, setUsername ] = useState("");
    const [ socialname, setSocialName ] = useState("");
    const [ bio, setBio ] = useState("");

    useEffect(() => {
        axios.get(`https://cloudify-backend.herokuapp.com/users/get/byid/${userid}`)
        .then(resp => {
            var data = resp.data;
            var userInfo = data.userInfo;

            setUsername(userInfo.username);
            setSocialName(userInfo.socialname);

            document.getElementById("userPicture").src = userInfo.profilePicture;

            var history = userInfo.browserHistory;

            history.forEach(searchedBook => {

                axios.get(`https://www.googleapis.com/books/v1/volumes/${searchedBook.bookId}`)
                .then(resp => {
                    var volumeInfo = resp.data.volumeInfo;
                    $("#booksHolder").append(` <div id="generatedBookDisplayer"> <img src="${volumeInfo.imageLinks.thumbnail}" /> </div> `)
                })
            });
        });
    }, []);

    return (
        <div className="app">

            <HeaderSearchBar />

            <div className="centered">
                <div id="userForm">

                    <Link to="/" > <FiHome style={{"color":"white", "fontSize":"32px"}} /> </Link>

                    <div id="userInfoHandler">

                        <div className="centered">
                            <h3 id="usernameDisplayer">@{username}</h3>
                        </div>

                        <div className="centered">
                            <img src="https://i.ibb.co/px3GVFk/icon-rounded.png" id="userPicture" />
                        </div>

                        <div className="centered">
                            <h1>Histório de pesquisa</h1>
                        </div>

                        <div className="centered">
                            <div id="booksHolder" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}